module.exports = __webpack_public_path__ + "ed2e77ce0aad4296686ed0826de71951.png";